/* ==========================================================================
   Dynoforce kentekenflow
   Formatteert het kenteken tijdens het typen, draait de scananimatie van
   ongeveer 1,1 seconde en vult daarna de resultaatkaart van de sectie.
   Data komt uit window.DFData; zie df-data.js voor de echte-API-omschakeling.

   Contract per sectie (zie ook snippets/df-kenteken-plaat.liquid):
   - form[data-df-kt] met input[data-df-kt-input] en [data-df-kt-status]
   - in dezelfde sectie een [data-df-kt-result] die start met [hidden]
   - tekstslots: [data-kt="..."] -> textContent
   - balken: [data-kt-bar="pk|nm"] -> breedte in procenten (origineel als
     aandeel van Stage 1), met een CSS-transition op width in de sectie
   ========================================================================== */

(function () {
  'use strict';

  /* De dienst schrijft de teksten, niet het thema. Alleen daar is bekend welk
     van de gevallen het is, en het verschil is commercieel: "we kennen je auto
     niet" jaagt iemand weg, "we kunnen je auto wel, we missen alleen het
     getal" levert een telefoontje op. Elk antwoord met gevonden:false stuurt
     sinds platformversie 3.161.0 een tekst mee in het veld fout.

     Let op de valkuil die ons hier eerder beet: niet_gevonden betekent aan die
     kant "auto is bekend, nog geen tuning in de lijst". Een kenteken dat niet
     bestaat heet kenteken_onbekend. Twee verschillende dingen, en het thema
     kan ze niet uit elkaar houden - dus moet het ze ook niet zelf willen
     verwoorden.

     Hieronder staat puur een vangnet voor een antwoord zonder fout-tekst.
     Platte tekst, geen HTML: de telefoon- en WhatsApp-link worden er los
     achter gezet, zodat er nooit opmaak uit een antwoord de pagina in kan. */
  var MELDINGEN = {
    kan_wel:           'Deze auto kunnen we tunen, alleen staan de cijfers er nog niet bij.',
    meerdere:          'Van deze auto bestaan meerdere uitvoeringen.',
    niet_gevonden:     'We kennen deze auto, maar er staat nog geen tuning voor in onze lijst.',
    geen_gegevens:     'We hebben te weinig gegevens van deze auto om mee te rekenen.',
    kenteken_onbekend: 'Dit kenteken staat niet in het register. Klopt het zo?',
    limiet:            'Je hebt net veel kentekens opgezocht. Probeer het over een paar minuten nog eens.',
    standaard:         'We kunnen hier nu geen cijfers bij vinden.'
  };

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sitebreed onthouden. De laatste geslaagde opvraging staat in localStorage
     onder df_kenteken: het nette kenteken plus het volledige zeker-antwoord.
     Daarmee vult elke pagina het veld voor in en zet de rekenkaart direct
     neer, uit het geheugen en dus zonder nieuwe opvraging. Na dertig dagen
     telt hij niet meer mee. Wissen gebeurt met de wisknop in het
     autokiezer-paneel; die zit in df-auto.js en wist beide sleutels. */
  var KT_SLEUTEL = 'df_kenteken';
  var KT_HOUDBAAR = 30 * 24 * 60 * 60 * 1000;

  function ktLees() {
    /* De datalaag houdt dit bij en kan terugvallen op sessionStorage als de
       browser localStorage weigert; daarom eerst daar vragen. */
    if (window.DFData && window.DFData.onthoudenKenteken) {
      return window.DFData.onthoudenKenteken();
    }
    try {
      var r = JSON.parse(localStorage.getItem(KT_SLEUTEL) || 'null');
      if (!r || !r.kt || !r.ts || Date.now() - r.ts > KT_HOUDBAAR) return null;
      return r;
    } catch (e) { return null; }
  }
  function ktBewaar(kt, v) {
    /* Schrijven loopt via de datalaag, want die bewaakt ook de terugval op
       sessionStorage en roept de wijziging om aan de rest van de pagina. */
    if (window.DFData && window.DFData.onthoudKenteken) {
      window.DFData.onthoudKenteken(kt, v);
      return;
    }
    try {
      localStorage.setItem(KT_SLEUTEL, JSON.stringify({ kt: kt, v: v || null, ts: Date.now() }));
    } catch (e) {}
  }

  function init(root) {
    root.querySelectorAll('form[data-df-kt]').forEach(function (form) {
      if (form.dataset.dfKtInit) return;
      form.dataset.dfKtInit = '1';

      var sectie = form.closest('.shopify-section') || document;
      var input = form.querySelector('[data-df-kt-input]');
      var plaat = form.querySelector('.df-kt');
      var status = form.querySelector('[data-df-kt-status]');
      var result = sectie.querySelector('[data-df-kt-result]');
      if (!input || !window.DFData) return;

      /* Haakje voor de handmatige tunekiezer (df-tunekiezer.js). Die kent merk,
         model en uitvoering maar geen kenteken, en hoort exact dezelfde
         resultaatkaart en keuzelijst te krijgen als de kentekenroute - anders
         staan er twee kaarten met elk hun eigen rekenwerk. Functiedeclaraties
         hoisten, dus deze verwijzingen mogen hier al staan.

         kies(v, u) neemt de gekozen rij over; keuze(v, kop) tekent de lijst. */
      form.dfKt = { kies: neem, keuze: kiesUitvoering };

      input.addEventListener('input', function () {
        input.value = window.DFData.formatPlate(input.value);
      });

      var knop = form.querySelector('button[type="submit"], [type="submit"]');
      var knopTekst = knop ? knop.textContent : '';

      /* De foto en het bijschrift horen bij de auto die in de kaart staat. Bij
         een nieuwe zoekactie moeten ze dus mee weg, anders staat de vorige auto
         nog in beeld naast de cijfers van de volgende - of naast een melding
         dat er geen cijfers zijn. */
      function wagenWeg() {
        if (!result) return;
        var w = result.parentElement ? result.parentElement.querySelector('[data-kt-wagen]') : null;
        if (!w) w = document.querySelector('[data-kt-wagen]');
        var blok = w && (w.closest('.df-kh__wagenblok') || w);
        if (blok) blok.hidden = true;
        if (w) w.removeAttribute('src');
        var bij = document.querySelector('[data-kt-bijschrift]');
        if (bij) bij.hidden = true;
      }

      /* Een opvraging duurt ongeveer twee seconden, en de eerste keer dat de
         dienst een auto ziet ruim drie. Twee seconden niets is lang; twee
         seconden met beweging niet. Daarom komt de kaart meteen in beeld, met
         balken op de plek van de cijfers. */
      function skelet(aan) {
        if (!result) return;
        if (aan) {
          result.hidden = false;
          result.classList.add('laden');
          /* De resultaatkaart staat een half scherm onder de plaat. Wie net zijn
             kenteken heeft ingetikt kijkt naar de plaat, en zag de laadbalken
             dus helemaal niet: die speelden zich onder de vouw af. vul() scrolt
             pas als het antwoord binnen is, dus precies gedurende die twee
             seconden wachten stond het skelet buiten beeld. Bij een tweede
             kenteken sta je al lager en zie je het wel, en dat is het verschil
             dat leest als "hij doet het soms niet".
             Alleen schuiven als de kaart echt niet in beeld staat, anders
             springt de pagina bij elke opvraging opnieuw. */
          var kader = result.getBoundingClientRect();
          if (!form.hasAttribute('data-no-scroll') && kader.top > window.innerHeight * 0.75) {
            result.scrollIntoView({
              behavior: reduced ? 'auto' : 'smooth',
              block: 'center'
            });
          }
          result.querySelectorAll('[data-kt]').forEach(function (el) {
            el.textContent = ' ';
          });
          result.querySelectorAll('[data-kt-bar]').forEach(function (el) {
            el.style.width = '0%';
          });
        } else {
          result.classList.remove('laden');
        }
      }

      var bezig = false;
      /* Het kenteken dat nu in de kaart staat. Zie de luisteraar op
         df:kenteken hieronder. */
      var getekendKt = '';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (bezig) return;
        var kt = input.value.trim();
        if (!kt) { input.focus(); return; }

        bezig = true;
        /* De vlag hierboven voorkomt een tweede opvraging al, maar zonder
           zichtbaar teken blijft iemand klikken. Elke klik telt mee voor de
           limiet en voor het fotoquotum. */
        if (knop) {
          knop.disabled = true;
          /* Uitgegrijsd zonder tekstverandering leest als "kapot" in plaats van
             "bezig". */
          knop.textContent = 'Zoeken…';
        }
        wagenWeg();
        status.textContent = 'We zoeken je auto op';
        status.classList.add('on');
        melding(false);
        if (!reduced && plaat) plaat.classList.add('scan');
        skelet(true);

        window.DFData.lookupPlate(kt).then(function (v) {
          klaar();
          /* Meer dan een uitvoering onder hetzelfde kenteken. Het antwoord
             heeft dan gevonden:false, maar het is geen misser: de cijfers
             zitten er al in, alleen weet de dienst niet welke rij het is.
             Dus geen belverzoek maar een keuzelijst. Een tweede opvraging is
             niet nodig; elke rij draagt zijn eigen vermogen en koppel. */
          if (v && v.status === 'meerdere') {
            var rijen = bruikbareUitvoeringen(v);
            if (rijen.length) {
              var vanzelf = bouwjaarTreffer(rijen);
              if (vanzelf) neem(v, vanzelf, true);
              else kiesUitvoering(v);
              return;
            }
          }
          if (!v || v.gevonden === false) {
            /* Alles zonder een uitdrukkelijke gevonden:false telt als treffer,
               zodat een antwoord dat het veld weglaat niet stilletjes als
               mislukt wordt gelezen. */
            geenTreffer(v, input.value.trim());
            return;
          }
          status.textContent = '';
          status.classList.remove('on');
          melding(false);
          vul(v);
        }).catch(function (err) {
          klaar();
          status.textContent = err.message;
          melding(true);
        });
      });

      /* Binnengekomen met een kenteken in de link, bijvoorbeeld via de knop op
         de homepagina? Vul hem in en zoek meteen op. Alleen op een pagina die
         de uitkomst ook kan tonen, en een keer per pagina: sommige pagina's
         hebben meer dan een kentekenveld. formatPlate knipt af op zes tekens,
         dus wat er ook in de link staat, er gaat niets geks het veld in. */
      if (result && !window.__dfKtUitLink) {
        var uitLink = new URLSearchParams(location.search).get('kenteken');
        if (uitLink) {
          window.__dfKtUitLink = true;
          input.value = window.DFData.formatPlate(uitLink);
          form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      }

      /* Sitebreed onthouden: het veld voorinvullen, en waar een resultaatkaart
         staat de laatste uitkomst direct neerzetten - uit het geheugen, dus
         zonder opvraging en zonder scroll. Een kenteken in de link gaat voor:
         dat is een verse vraag. Eén kaart per pagina, zelfde patroon als de
         link-route hierboven. Bootmod3 heeft geen resultaatkaart en krijgt
         dus alleen het vooringevulde veld; de eigen flow daar blijft met
         rust. */
      var onthouden = ktLees();
      if (onthouden && !input.value) {
        input.value = window.DFData.formatPlate(onthouden.kt);
      }
      if (result && onthouden && onthouden.v && onthouden.v.vermogen && onthouden.v.koppel &&
          !window.__dfKtUitLink && !window.__dfKtUitCache) {
        window.__dfKtUitCache = true;
        var hadNoScroll = form.hasAttribute('data-no-scroll');
        form.setAttribute('data-no-scroll', '');
        vul(onthouden.v);
        /* vul() kijkt pas een frame later of hij mag scrollen, dus het merkje
           moet nog even blijven staan voordat het terug mag naar hoe de
           sectie hem had. */
        if (!hadNoScroll) {
          setTimeout(function () { form.removeAttribute('data-no-scroll'); }, 400);
        }
      }

      /* Zoekt de bezoeker elders op deze pagina een ander kenteken op - in
         het menupaneel bijvoorbeeld - dan hoort deze kaart niet bij een
         andere auto te blijven staan. Bij een volledig antwoord tekenen we
         hem opnieuw, anders gaat hij dicht. Onze eigen zoekactie slaan we
         over: die handelt zichzelf af, van skelet tot kaart. */
      document.addEventListener('df:kenteken', function (e) {
        if (!result || bezig) return;
        var d = (e && e.detail) ? e.detail : null;
        if (!d || !d.kt) return;
        /* Wat we zelf net getekend hebben komt via de datalaag als bericht
           terug; daar hoeven we niet nog een keer op te tekenen. */
        if (d.kt === getekendKt) return;
        var nu = result.querySelector('[data-kt="kenteken"]');
        if (nu && nu.textContent === d.kt) return;
        if (d.v && d.v.vermogen && d.v.koppel) {
          var hadNoScroll2 = form.hasAttribute('data-no-scroll');
          form.setAttribute('data-no-scroll', '');
          vul(d.v);
          if (!hadNoScroll2) {
            setTimeout(function () { form.removeAttribute('data-no-scroll'); }, 400);
          }
        } else if (result.classList.contains('on')) {
          result.classList.remove('on');
          result.hidden = true;
        }
      });

      /* Alleen rijen waar we ook echt iets mee kunnen. vul() rekent met
         vermogen en koppel; ontbreekt een van beide, dan is die rij geen
         keuze maar een fout in de maak. */
      function bruikbareUitvoeringen(v) {
        if (!Array.isArray(v.uitvoeringen)) return [];
        return v.uitvoeringen.filter(function (u) {
          return u && u.vermogen && u.koppel &&
                 typeof u.vermogen.origineel === 'number' && typeof u.vermogen.stage1 === 'number' &&
                 typeof u.koppel.origineel === 'number' && typeof u.koppel.stage1 === 'number';
        });
      }

      /* Draagt precies een rij de vlag past_bij_bouwjaar, dan is dat degene die
         wij zelf ook zouden kiezen en passen we hem meteen toe. Dan hoeft de
         bezoeker niet te klikken voor een keuze die eigenlijk al vaststaat.

         Bij nul treffers geeft het bouwjaar geen uitsluitsel en is het een
         echte vraag. Bij meer dan een ook: dan weten we het nog steeds niet.
         In allebei die gevallen tonen we gewoon de lijst.

         Strikt op true vergelijken is hier expres. Komt er ooit een 1 of een
         "true" uit de dienst, dan valt hij door naar de keuzelijst - dat is
         het gedrag van voorheen en dus veilig. */
      function bouwjaarTreffer(rijen) {
        var raak = rijen.filter(function (u) { return u.past_bij_bouwjaar === true; });
        return raak.length === 1 ? raak[0] : null;
      }

      /* De keuzelijst. Alles met createElement en textContent: de namen komen
         van buiten en horen geen opmaak mee te kunnen brengen.

         De generatie staat er met opzet bij. Twee rijen kunnen exact dezelfde
         naam hebben - "3.0 TDI 204pk" voor zowel de MK1 als de MK2 - en dan
         kiest iemand tussen twee gelijke knoppen. De generatie en de winst
         maken het verschil zichtbaar. */
      function kiesUitvoering(v, kopTekst) {
        var rijen = bruikbareUitvoeringen(v);
        status.textContent = '';
        status.classList.remove('on');
        melding(false);

        var blok = document.createElement('div');
        blok.className = 'df-ktkies__blok';

        var kop = document.createElement('p');
        kop.className = 'df-ktkies__kop';
        /* Ook hier schrijft de dienst de tekst; die van ons is het vangnet. */
        kop.textContent = kopTekst || v.fout ||
          ([v.merk, v.model, v.bouwjaar].filter(Boolean).join(' ') +
           ' kent meerdere uitvoeringen. Welke heb jij?');
        blok.appendChild(kop);

        var lijst = document.createElement('div');
        lijst.className = 'df-ktkies';
        lijst.setAttribute('role', 'group');
        lijst.setAttribute('aria-label', 'Kies je uitvoering');

        rijen.forEach(function (u) {
          var knop = document.createElement('button');
          knop.type = 'button';
          knop.className = 'df-ktkies__rij';

          var tekst = document.createElement('span');
          tekst.className = 'df-ktkies__tekst';

          var naam = document.createElement('b');
          naam.textContent = u.naam || 'Onbekende uitvoering';
          tekst.appendChild(naam);

          var onder = u.generatie || (u.jaar_vanaf ? 'vanaf ' + u.jaar_vanaf : '');
          if (onder) {
            var sub = document.createElement('span');
            sub.textContent = onder;
            tekst.appendChild(sub);
          }
          knop.appendChild(tekst);

          var winst = document.createElement('i');
          winst.className = 'df-ktkies__winst';
          winst.textContent = u.vermogen.origineel + ' → ' + u.vermogen.stage1 + ' ' +
                              (u.vermogen.eenheid || 'pk');
          knop.appendChild(winst);

          knop.addEventListener('click', function () { neem(v, u); });
          lijst.appendChild(knop);
        });

        blok.appendChild(lijst);
        status.appendChild(blok);
        if (rijen.length) lijst.firstChild.focus({ preventScroll: true });
        return blok;
      }

      /* Een gekozen rij maakt van het antwoord alsnog een treffer. De rij
         draagt vermogen en koppel in exact dezelfde vorm als bij een zeker
         antwoord, dus we zetten ze er overheen en laten vul() zijn werk doen.
         De id bewaren we bij het resultaat: daarmee is later vast te leggen
         wat de bezoeker koos. */
      function neem(v, u, opBouwjaar) {
        var g = {};
        Object.keys(v).forEach(function (k) { g[k] = v[k]; });
        delete g.uitvoeringen;
        g.gevonden = true;
        g.status = 'zeker';
        g.vermogen = u.vermogen;
        g.koppel = u.koppel;
        if (u.naam) g.motorisering = u.naam;
        if (u.generatie) g.generatie = u.generatie;
        if (u.id != null && result) result.dataset.uitvoering = u.id;

        status.textContent = '';
        melding(false);
        vul(g);
        zetGekozenRegel(u, opBouwjaar);
      }

      /* Welke uitvoering het geworden is, staat naast de autonaam: de naam
         alleen zegt niet welke van de twee het is. Hier stond ook een knopje
         "andere uitvoering" dat de keuzelijst terughaalde; dat is eruit, want
         de bezoeker kiest een andere uitvoering nu gewoon in de lijsten boven
         de kaart. */
      function zetGekozenRegel(u, opBouwjaar) {
        if (!result) return;
        var naam = result.querySelector('[data-kt="auto"]');
        if (!naam || !naam.parentElement) return;

        var oud = result.querySelector('.df-ktkies__gekozen');
        if (oud) oud.parentElement.removeChild(oud);

        var delen = [];
        if (u.generatie) delen.push(u.generatie);
        /* Heeft de bezoeker zelf niets aangeklikt, dan hoort hij te zien dat
           wij die keuze hebben gemaakt en waarop. Anders staan er cijfers over
           zijn auto waar hij nooit ja tegen heeft gezegd. */
        if (opBouwjaar) delen.push('gekozen op bouwjaar');
        if (!delen.length) return;

        var regel = document.createElement('span');
        regel.className = 'df-ktkies__gekozen';
        regel.textContent = delen.join(' · ');
        naam.parentElement.insertBefore(regel, naam.nextSibling);
      }

      /* Wat de bezoeker leest als er geen cijfers zijn. Alles wordt opgebouwd
         uit losse knopen: de tekst komt van buiten en mag geen opmaak mee de
         pagina in brengen. */
      function geenTreffer(v, kt) {
        var reden = v && v.status;
        /* Geen cijfers betekent: geen kaart. Het skelet heeft hem zichtbaar
           gemaakt om het wachten te vullen; blijft hij daarna staan, dan kijkt
           de bezoeker naar een leeg kader onder een melding. */
        if (result) result.hidden = true;
        wagenWeg();
        status.textContent = '';
        melding(true);
        status.appendChild(document.createTextNode(
          (v && v.fout) || MELDINGEN[reden] || MELDINGEN.standaard));

        /* Bij een limiet nodigen we niet uit om te bellen. Dat is geen klant
           met een vraag maar iemand die te snel achter elkaar klikt. */
        if (reden === 'limiet') return;

        contactregel(v, kt, reden);
      }

      /* WhatsApp en telefoon als echte links onder de melding. De tekst
         schrijft de dienst, klikbaar maken is aan het thema.

         Bewust op een eigen regel en zonder verbindende woorden: de teksten
         van de dienst eindigen vaak al met "bel of app ons gerust". Zetten we
         daar een zin achteraan, dan staat het er twee keer. Zo leest het als
         de contactgegevens die bij die zin horen. */
      function contactregel(v, kt, reden) {
        var auto = v ? [v.merk, v.model, v.motorisering].filter(Boolean).join(' ') : '';
        var wat = kt || 'auto';
        if (auto) wat += ' (' + auto + ')';
        /* Bij kan_wel weten we wat de vraag is en vullen we hem voor. In de
           andere gevallen niet: bij een elektrische auto zou "wat levert Stage
           1 op" een onzinvraag zijn om iemand in de mond te leggen. */
        var bericht = reden === 'kan_wel'
          ? 'Hoi, wat levert Stage 1 op voor mijn ' + wat + '?'
          : 'Hoi, ik heb een vraag over mijn ' + wat + '.';

        var regel = document.createElement('span');
        regel.className = 'df-ktstat__acties';

        var wa = document.createElement('a');
        wa.href = 'https://wa.me/31525796515?text=' + encodeURIComponent(bericht);
        wa.target = '_blank';
        wa.rel = 'noopener';
        wa.textContent = 'App ons';
        regel.appendChild(wa);

        regel.appendChild(document.createTextNode(' · '));

        var tel = document.createElement('a');
        tel.href = 'tel:0525796515';
        tel.textContent = '0525-796515';
        regel.appendChild(tel);

        status.appendChild(regel);
      }

      /* Kader om de statusregel, maar alleen bij een echte uitkomst.
         Tijdens het zoeken en bij de gewone hint hoort hij plat te blijven. */
      function melding(aan) {
        if (status) status.classList.toggle('df-melding', !!aan);
      }

      function klaar() {
        bezig = false;
        if (knop) { knop.disabled = false; knop.textContent = knopTekst; }
        skelet(false);
        status.classList.remove('on');
        if (plaat) plaat.classList.remove('scan');
      }

      function vul(v) {
        if (!result) return;
        /* Van een vorige zoekactie kan er nog een keuzeregel in de kaart
           staan; die hoort niet bij deze auto. */
        var vorige = result.querySelector('.df-ktkies__gekozen');
        if (vorige) vorige.parentElement.removeChild(vorige);
        var pkPlus = v.vermogen.stage1 - v.vermogen.origineel;
        var nmPlus = v.koppel.stage1 - v.koppel.origineel;
        /* De API geeft het kenteken zonder streepjes terug (RJ066B). Op het
           scherm en in de doorklik-link willen we de leesbare vorm. */
        var ktNet = window.DFData.formatPlate(v.kenteken || (input && input.value) || '');
        getekendKt = ktNet;
        /* Dit is het ene succespad, ook na een uitvoeringkeuze en bij een
           kenteken uit de link - dus hier onthouden we kenteken en antwoord
           voor de rest van de site. */
        if (ktNet) ktBewaar(ktNet, v);
        /* De chassiscode vooraan in motorisering ("G05 - 4.4 Bi-Turbo ...")
           komt uit het platform en klopt niet altijd: een X5 M is een F95,
           maar het platform zet er G05 voor. In de kop van de kaart laten we
           die code daarom weg; de motor en het vermogen erachter kloppen wel.
           Alleen voor de weergave, het antwoord zelf blijft heel. */
        var motor = String(v.motorisering || '')
          .replace(/^[A-Za-z]{0,2}\d{1,3}(?:\.\d)?[A-Za-z]{0,2}(?:[- ]?(?:LCI|FL))?\s*[-\u2013:]\s+/, '');
        var data = {
          'kenteken': ktNet,
          'auto': [v.merk, v.model, motor].filter(Boolean).join(' '),
          'merk': v.merk,
          'bouwjaar': v.bouwjaar || '',
          'brandstof': v.brandstof || '',
          'pk-van': v.vermogen.origineel + ' pk',
          'pk-naar': v.vermogen.stage1 + ' pk',
          'pk-plus': '+' + pkPlus + ' pk',
          'pk-pct': '+' + Math.round(pkPlus / v.vermogen.origineel * 100) + '%',
          'nm-van': v.koppel.origineel + ' Nm',
          'nm-naar': v.koppel.stage1 + ' Nm',
          'nm-plus': '+' + nmPlus + ' Nm',
          'nm-pct': '+' + Math.round(nmPlus / v.koppel.origineel * 100) + '%'
        };
        Object.keys(data).forEach(function (k) {
          result.querySelectorAll('[data-kt="' + k + '"]').forEach(function (el) {
            el.textContent = data[k];
          });
        });

        var balken = {
          pk: Math.round(v.vermogen.origineel / v.vermogen.stage1 * 100),
          nm: Math.round(v.koppel.origineel / v.koppel.stage1 * 100)
        };

        /* Voertuigfoto uit het antwoord. Het is een adres, geen bestand: de
           browser haalt hem bij het CDN van de leverancier op. De srcset en
           sizes van de themafoto moeten weg, anders wint die van de nieuwe src.
           Het slot staat buiten de resultaatkaart, dus zoeken op sectieniveau. */
        var wagen = sectie.querySelector('[data-kt-wagen]');
        var wagenblok = wagen && (wagen.closest('.df-kh__wagenblok') || wagen);
        /* Het bijschrift staat rechtsonder in de kaart, los van het fotoblok,
           maar hoort er wel bij: zonder foto slaat "Voorbeeldfoto van dit
           model" nergens op. Daarom gaan ze samen aan en uit. */
        var bijschrift = sectie.querySelector('[data-kt-bijschrift]');
        function toonWagen(aan) {
          if (wagenblok) wagenblok.hidden = !aan;
          if (bijschrift) bijschrift.hidden = !aan;
        }
        /* Geen foto bij dit antwoord? Dan ook geen foto van de vorige auto
           laten staan. */
        if (!v.afbeelding) toonWagen(false);
        if (wagen && v.afbeelding) {
          wagen.removeAttribute('srcset');
          wagen.removeAttribute('sizes');
          /* Niet meer uitstellen: de bezoeker heeft er net om gevraagd en het
             beeld staat in zicht. Met lazy wacht de browser op een
             zichtbaarheidscontrole en dat is hier alleen maar vertraging. */
          wagen.loading = 'eager';
          /* Het adres van hun CDN is ondertekend en houdbaar tot een bepaald
             moment. Valt hij weg, dan liever niets dan een kapot beeldje over
             de fotokop heen. */
          /* hidden in plaats van een klasse: het blok staat al verborgen in de
             HTML, zodat de bezoeker tijdens het laden geen voorbeeldfoto ziet
             voordat de stylesheet er is. Pas als deze foto binnen is mag het
             blok zichtbaar worden, en valt hij weg dan gaat hij weer dicht. */
          wagen.onerror = function () { toonWagen(false); };
          wagen.onload = function () { toonWagen(true); };
          wagen.alt = [v.merk, v.model, motor].filter(Boolean).join(' ');
          if (wagen.src === v.afbeelding && wagen.complete && wagen.naturalWidth) {
            /* Zelfde foto als net: het load-moment komt dan niet nog een keer,
               dus zelf openzetten. */
            toonWagen(true);
          } else {
            /* Eerst dicht. Anders staat bij een tweede kenteken de auto van de
               vorige zoekactie nog naast de nieuwe cijfers. */
            toonWagen(false);
            wagen.src = v.afbeelding;
          }
        }

        /* Vanaf deze kaart klikt de bezoeker door, bijvoorbeeld van de
           homepagina naar chiptuning. Neem het kenteken mee in die links,
           anders moet hij het daar opnieuw intikken. Alleen links binnen de
           eigen site, en netjes via URL zodat een bestaande ?dienst= blijft
           staan. */
        var ktLink = ktNet;
        if (ktLink) {
          result.querySelectorAll('a[href]').forEach(function (a) {
            var u;
            try { u = new URL(a.getAttribute('href'), location.origin); }
            catch (err) { return; }
            if (u.origin !== location.origin) return;
            u.searchParams.set('kenteken', ktLink);
            a.setAttribute('href', u.pathname + u.search + u.hash);
          });
        }

        result.hidden = false;
        /* Twee delen in de balk: het grijze origineel staat er meteen, het
           rode stuk begint waar het grijs ophoudt en groeit tot de rand. Een
           kaart met alleen [data-kt-bar] (zonder basis) werkt nog net zo:
           dan begint het rood gewoon op nul. */
        result.querySelectorAll('[data-kt-basis]').forEach(function (b) {
          b.style.width = balken[b.dataset.ktBasis] + '%';
        });
        result.querySelectorAll('[data-kt-bar]').forEach(function (b) {
          var basis = b.parentElement && b.parentElement.querySelector('[data-kt-basis]');
          b.style.left = basis ? balken[b.dataset.ktBar] + '%' : '0%';
          b.style.width = '0%';
        });

        requestAnimationFrame(function () {
          result.classList.add('on');
          var zet = function () {
            result.querySelectorAll('[data-kt-bar]').forEach(function (b) {
              var basis = b.parentElement && b.parentElement.querySelector('[data-kt-basis]');
              b.style.width = (basis ? 100 - balken[b.dataset.ktBar] : balken[b.dataset.ktBar]) + '%';
            });
          };
          if (reduced) { zet(); }
          else { setTimeout(zet, 150); }
          if (!form.hasAttribute('data-no-scroll')) {
            result.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          }
        });
      }
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
